import React, { useEffect, useState, useRef } from 'react';
import { Loader } from '@googlemaps/js-api-loader';

const GOOGLE_MAPS_BASE =
  "https://maps.googleapis.com/maps/api/js?libraries=places,marker";






function RestAreaForm({ 
  googleMapsKey = "",
  initialValues = { restPoint: '', restTime: '', restMap: '', restLat: '', restLng: '' },
  initialStart = { startPoint: '', startTime: '', startMap: '', startLat: '', startLng: '' },
  initialGoal = { goalPoint: '', goalTime: '', goalMap: '', goalLat: '', goalLng: '' },
}) 
{
  const [restAreas, setRestAreas] = useState([initialValues, initialValues, initialValues]);
  const [startArea, setStartArea] = useState(initialStart);
  const [goalArea, setGoalArea] = useState(initialGoal);
  const [highwaysFlg, setHighwaysFlg] = useState(false);
  const [tollsFlg, setTollsFlg] = useState(false);
  const [ferriesFlg, setFerriesFlg] = useState(false);

  const autocompleteRef = useRef([]);

  const handleInputStartChange = (field, value) => {
    setStartArea(prevStartArea => {
      return {...prevStartArea, [field]: value};
    });
  };

  const handleInputGoalChange = (field, value) => {
    setGoalArea(prevGoalArea => {
      return {...prevGoalArea, [field]: value};
    });
  };

  const handleInputChange = (index, field, value) => {
    setRestAreas((prevRestAreas) => {
      return prevRestAreas.map((restArea, idx) => {
        if (idx !== index) {
          return restArea;
        }
  
        return {
          ...restArea,
          [field]: value,
        };
      });
    });
  };

  // useEffect(() => {
  //   initMap();
  // }, []);
  // useEffect(() => {
  //   // Google がまだなら何もしない
  //   if (!window.google || !window.google.maps) return;

  //   initMap();
  // }, []);

    useEffect(() => {
      if (!googleMapsKey) {
        console.error("Google Maps API key is missing");
        return;
      }

      // 既にロード済みなら即 init
      if (window.google && window.google.maps) {
        initMap();
        return;
      }

      // 二重読み込み防止
      if (document.getElementById("google-maps-script")) return;

      const script = document.createElement("script");
      script.id = "google-maps-script";
      script.src = `${GOOGLE_MAPS_BASE}&key=${googleMapsKey}&callback=initMap`;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);

      // グローバル callback が必要なら
      window.initMap = () => {
        initMap();
      };
    }, [googleMapsKey]);

  useEffect(() => {
    // Google Mapsをロード
    const loader = new Loader({
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY, // Google MapsのAPIキーを設定
      version: 'weekly',
      libraries: ['places'],
    });

    loader.load().then(() => {
      // StartPoint用のオートコンプリート設定
      const startInput = document.getElementById('start_point');
      const startAutocomplete = new google.maps.places.Autocomplete(startInput);
      startAutocomplete.addListener('place_changed', () => {
        const place = startAutocomplete.getPlace();
        handleInputStartChange('startPoint', place.name);
        handleInputStartChange('startMap', place.url);

        const startPoint_name = document.getElementById("start_point");

        startPoint_name.value = place.name

        const startpoint = place.geometry.location;

        handleInputStartChange('startLat', startpoint.lat());
        handleInputStartChange('startLng', startpoint.lng());
      });

      // GoalPoint用のオートコンプリート設定
      const goalInput = document.getElementById('goal_point');
      const goalAutocomplete = new google.maps.places.Autocomplete(goalInput);
      goalAutocomplete.addListener('place_changed', () => {
        const place = goalAutocomplete.getPlace();
        handleInputGoalChange('goalPoint', place.name);
        handleInputGoalChange('goalMap', place.url);

        const goalPoint_name = document.getElementById("goal_point");

        goalPoint_name.value = place.name

        const goalpoint = place.geometry.location;

        handleInputGoalChange('goalLat', goalpoint.lat());
        handleInputGoalChange('goalLng', goalpoint.lng());
      });

      // Google Mapsがロードされた後の処理を記述
      // ここでは、オートコンプリートの設定を行います
      restAreas.forEach((_, index) => {
        const input = document.getElementById(`touring_group_touring_group_rests_attributes_${index}_rest_point`);
        autocompleteRef.current[index] = new google.maps.places.Autocomplete(input);
        const autocomplete = new google.maps.places.Autocomplete(input);

        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          handleInputChange(index, 'restPoint', place.name);
          handleInputChange(index, 'restMap', place.url);

          const restPoint_name = document.getElementsByClassName("rest_point")[index];

          restPoint_name.value = place.name

          const restpoint = place.geometry.location;

          handleInputChange(index, 'restLat', restpoint.lat());
          handleInputChange(index, 'restLng', restpoint.lng());
        });
      });

      console.log("useEffectが動きました");

    });
  }, [restAreas, startArea, goalArea]);

  return (
    <>
      {/* Start point input fields */}
      <div>
        <h2>★出発地★</h2>
        <table className="touring-time-table">
          <tbody>
            <tr>
              <td className=""><label className="touring-table-label" htmlFor="place">場所</label></td>
            </tr>
            <tr>
              <td className="touring-time-table-place-details">
                <input
                  type="text"
                  name="start_point"
                  id="start_point"
                  required
                  placeholder="Google Map を検索する"
                  // value={startPoint}
                  onBlur={e => handleInputStartChange('startPoint', e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className="touring-time-table-time"><label className="touring-table-label" htmlFor="start_time">出発時刻</label></td>
            </tr>
            <tr>
              <td>
                <input
                  id="touring_group_start_time" 
                  type="datetime-local" 
                  name="touring_group[start_time]" 
                  required="required"
                  // value={startTime}
                  onBlur={e => handleInputStartChange('startTime', e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </table>
        <input type="hidden" id="hidden_start_point" name="touring_group[start_point]" value={startArea.startPoint} />
        <input type="hidden" id="hidden_start_time" name="touring_group[start_time]" value={startArea.startTime} />
        <input type="hidden" id="hidden_start_map" name="touring_group[start_map]" value={startArea.startMap} />
        <input type="hidden" id="hidden_start_lat" name="touring_group[start_lat]" value={startArea.startLat} />
        <input type="hidden" id="hidden_start_lng" name="touring_group[start_lng]" value={startArea.startLng} />
      </div>

      
      {restAreas.map((restArea, index) => (
        <div key={index}>
          <h2>（休憩地）</h2>
          <table className="touring-time-table">
            <tbody>
              <tr>
                <td className=""><label className="touring-table-label" htmlFor="place">場所</label></td>
              </tr>
              <tr>
                <td className="touring-time-table-place-details">
                  <input 
                    // value={restArea.restPoint}
                    onBlur={(e) => handleInputChange(index, 'restPoint', e.target.value)}
                    className="rest_point  pac-target-input"
                    placeholder="Google Map を検索する" type="text" name={`touring_group[touring_group_rests_attributes][${index}][rest_point]`} id={`touring_group_touring_group_rests_attributes_${index}_rest_point`}  autoComplete="off"
                  />
                  {/* <img src="touring-group/magnifying-glass-white.png" alt="検索眼鏡" /> */}
                </td>
              </tr>
              <tr>
                <td className="touring-time-table-time">
                  <label className="touring-table-label" htmlFor="rest_time">出発時刻</label>
                </td>
              </tr>
              <tr>
                <td>
                  <input 
                    id="rest_time"
                    className="rest_time"
                    type="datetime-local" 
                    name={`touring_group[touring_group_rests_attributes][${index}][rest_time]`}
                    onBlur={(e) => handleInputChange(index, 'restTime', e.target.value)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <input type="hidden" id={`hidden_rest_point_${index}`} name={`touring_group[touring_group_rests_attributes][${index}][rest_point]`} value={restArea.restPoint} />

          <input type="hidden" id={`hidden_rest_time_${index}`} name={`touring_group[touring_group_rests_attributes][${index}][rest_time]`} value={restArea.restTime} />

          <input type="hidden" id={`hidden_rest_map_${index}`} name={`touring_group[touring_group_rests_attributes][${index}][rest_map]`} value={restArea.restMap} />

          <input type="hidden" id={`hidden_rest_lat_${index}`} name={`touring_group[touring_group_rests_attributes][${index}][rest_lat]`} value={restArea.restLat} />

          <input type="hidden" id={`hidden_rest_lng_${index}`} name={`touring_group[touring_group_rests_attributes][${index}][rest_lng]`} value={restArea.restLng} />
        </div>
      ))}

      {/* Goal point input fields */}
      <div>
        <h2>★目的地★</h2>
        <table className="touring-time-table">
          <tbody>
          <tr>
            <td className=""><label className="touring-table-label" htmlFor="place">場所</label></td>
          </tr>
          <tr>
            <td className="touring-time-table-place-details">
              <input
                type="text"
                // value={goalPoint}
                onBlur={e => handleInputGoalChange('goalPoint', e.target.value)}
                id="goal_point"
                required
                placeholder="Google Map を検索する"
              />
            </td>
          </tr>
          <tr>
            <td className="touring-time-table-time"><label className="touring-table-label" htmlFor="goal_time">到着時刻</label></td>
          </tr>
          <tr>
            <td>
              <input
                id="touring_group_goal_time"
                type="datetime-local"
                name="touring_group[goal_time]" 
                required="required"                
                // value={goalTime}
                onBlur={e => handleInputGoalChange('goalTime', e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <td>

            </td>
          </tr>
          </tbody>
        </table>
        <input type="hidden" id="hidden_goal_point" name="touring_group[goal_point]" value={goalArea.goalPoint} />
        <input type="hidden" id="hidden_goal_time" name="touring_group[goal_time]" value={goalArea.goalTime} />
        <input type="hidden" id="hidden_goal_map" name="touring_group[goal_map]" value={goalArea.goalMap} />
        <input type="hidden" id="hidden_goal_lat" name="touring_group[goal_lat]" value={goalArea.goalLat} />
        <input type="hidden" id="hidden_goal_lng" name="touring_group[goal_lng]" value={goalArea.goalLng} />
      </div>

      <h2 className="sub-title options">オプション</h2>
      <div className="option_checkbox">
        <input 
          type="checkbox" 
          id="highways_checkbox" 
          checked={highwaysFlg} 
          onChange={() => setHighwaysFlg(!highwaysFlg)} 
        />
        高速道路の除外
      </div>
      <div className="option_checkbox">
        <input 
          type="checkbox" 
          id="tolls_checkbox" 
          checked={tollsFlg} 
          onChange={() => setTollsFlg(!tollsFlg)} 
        />
        有料区間の除外
      </div>
      <div className="option_checkbox">
        <input 
          type="checkbox" 
          id="ferries_checkbox" 
          checked={ferriesFlg} 
          onChange={() => setFerriesFlg(!ferriesFlg)} 
        />
        フェリー利用なし
      </div>
      <input type="hidden" id="highways_hidden" name="touring_group[highways_flg]" value={highwaysFlg} />
      <input type="hidden" id="tolls_hidden" name="touring_group[tolls_flg]" value={tollsFlg} />
      <input type="hidden" id="ferries_hidden" name="touring_group[ferries_flg]" value={ferriesFlg} />

      <h2 className="sub-title">マップ</h2>
      <div className="touring-group-map" id="map"></div>
    </>
  );
}


// グローバルスコープでrestPointsを定義
// let restPoints = [];

function initMap() {
  // 地図のインスタンスを生成
  const map = new google.maps.Map(document.getElementById('map'), {
    center: {lat: 35.710063, lng: 139.810700},
    zoom: 5
  });

  // 経路案内のためのインスタンスを生成
  const directionsService = new google.maps.DirectionsService();
  const directionsRenderer = new google.maps.DirectionsRenderer();

  // 経路描画の設定
  directionsRenderer.setMap(map);

  // 出発地と目的地の座標を設定
  var origin = new google.maps.LatLng(start_lat, start_lng);
  var destination = new google.maps.LatLng(goal_lat, goal_lng);

  // 経路のリクエスト
  var request = {
    origin: origin,
    destination: destination,
    avoidFerries: avoidFerrie,
    avoidHighways: avoidHighways,
    avoidTolls: avoidTolls,
    travelMode: google.maps.TravelMode.DRIVING
  };

  // 経路を取得し、地図上に描画
  directionsService.route(request, function(result, status) {
    if (status == google.maps.DirectionsStatus.OK) {
      directionsRenderer.setDirections(result);
    }
  });

  const form = document.querySelector("form"); // フォーム要素を取得
  const startPointInput = document.getElementById("start_point");
  const goalPointInput = document.getElementById("goal_point");
  const restPointInputs = document.getElementsByClassName("rest_point");
  const autocompletes = [];

  const onChangeHandler = function () {
    const startPoint = document.getElementById("start_point");
    const goalPoint = document.getElementById("goal_point");
  
    // 出発地と目的地の入力フィールドが空でないことを確認
    if (startPoint.value && goalPoint.value) {
      calculateAndDisplayRoute(directionsService, directionsRenderer);
    }
  };

  const startPoint = document.getElementById("start_point");
  const goalPoint = document.getElementById("goal_point");
  
  document.getElementById("start_point").addEventListener("change", onChangeHandler);
  document.getElementById("goal_point").addEventListener("change", onChangeHandler);
  
  // 経由地の入力フィールドにイベントリスナを追加
  // restPointsに現在の休憩地を追加
  const restPoints = Array.from(document.getElementsByClassName("rest_point"));
  restPoints.forEach((restPoint) => {
    restPoint.addEventListener("change", onChangeHandler);
  });

  // チェックボックスのイベントリスナを追加
  document.getElementById("highways_checkbox").addEventListener("change", onChangeHandler);
  document.getElementById("tolls_checkbox").addEventListener("change", onChangeHandler);
  document.getElementById("ferries_checkbox").addEventListener("change", onChangeHandler);

}

function calculateAndDisplayRoute(directionsService, directionsRenderer) {
  // 1. 経由地の入力フィールドから値を取得する
  const restPoints = document.getElementsByClassName("rest_point");

  // 2. 値をGoogle Maps APIに渡せる形式に変換する
  const waypoints = Array.from(restPoints).map((restPoint) => {
    // 空の経由地を除外
    if (restPoint.value) {
      return {
        location: { query: restPoint.value },
        stopover: true,
      };
    }
    return null;
  }).filter((waypoint) => waypoint !== null); // null の要素を除外

  // 3. directionsService.routeメソッドのオプションにwaypointsを追加する
  directionsService
    .route({
      origin: {
        query: document.getElementById("start_point").value,
      },
      destination: {
        query: document.getElementById("goal_point").value,
      },
      waypoints: waypoints,
      avoidFerries: document.getElementById("ferries_checkbox").checked,
      avoidHighways: document.getElementById("highways_checkbox").checked,
      avoidTolls: document.getElementById("tolls_checkbox").checked,
        travelMode: google.maps.TravelMode.DRIVING,
      })
    .then((response) => {
      directionsRenderer.setDirections(response);
    });
}

export default RestAreaForm;

